<template>
  <div>
    <p style="color: red">
      <b>Let op!</b>
    </p>
    <p style="color: red">
      Stuur bij elke zending altijd de Wolk oplader (inclusief kabel) mee.
      Bij een omruiling (andere maat, type of defect) ontvang je van ons altijd een nieuwe oplader.
    </p>
  </div>
</template>

<script>
export default {
  name: 'WolkChargerWarning',
};
</script>
